import * as React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger } from '../../../../web/components-v2/Select';
import { styleSheet } from '../styles';
import { IOptionItem } from '../types';

interface IProps<T> {
	ariaLabel?: string;
	disabled?: boolean;
	id?: string;
	onSelect: (option: IOptionItem<T>) => void;
	options: IOptionItem<T>[];
	selected: IOptionItem<T> | null | undefined;
}

export function OptionSelect<T>({ ariaLabel, disabled, id, onSelect, options, selected }: IProps<T>) {
	return (
		<Select
			disabled={disabled}
			value={selected?.id ?? null}
			onValueChange={value => {
				const option = options.find(o => o.id === value);
				if (option) onSelect(option);
			}}
		>
			<SelectTrigger id={id} aria-label={ariaLabel} styles={styleSheet.fillTrigger}>
				<span>{selected?.text ?? 'Select...'}</span>
			</SelectTrigger>
			<SelectContent>
				{options.map(option => (
					<SelectItem key={option.id} value={option.id}>
						{option.text}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
}
